export type MediaStorageStatus = {
  storage_mode: 'local' | 'oss';
  usage_bytes: number;
  quota_bytes: number | null;
  warn_threshold_bytes: number | null;
  at_quota: boolean;
  near_quota: boolean;
  upload_blocked: boolean;
  oss_configured: boolean;
  oss_tested: boolean;
};

/** 兼容接口仍可能返回历史值 oss_cdn */
export function isOssStorageMode(mode: string | null | undefined): boolean {
  const m = (mode ?? '').toLowerCase();
  return m === 'oss' || m === 'oss_cdn';
}

export const MEDIA_QUOTA_EVENT = 'wes-media-quota-blocked';

export function formatMediaBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '0 B';
  if (n < 1024) return `${n} B`;
  if (n < 1048576) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1073741824) return `${(n / 1048576).toFixed(1)} MB`;
  return `${(n / 1073741824).toFixed(2)} GB`;
}

export function mediaUsagePercent(usage: number, quota: number | null): number {
  if (quota == null || quota <= 0) return 0;
  return Math.min(100, Math.round((usage / quota) * 100));
}

export function dispatchMediaQuotaBlocked(detail?: MediaStorageStatus): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(MEDIA_QUOTA_EVENT, { detail }));
}

/** 上传前客户端拦截（服务端仍会二次校验） */
export function assertClientMediaUploadAllowed(status: MediaStorageStatus | null | undefined): boolean {
  if (!status || isOssStorageMode(status.storage_mode)) return true;
  if (!status.upload_blocked) return true;
  dispatchMediaQuotaBlocked(status);
  return false;
}
